import { ParserFunction } from '../type';

export const numberOfVotesLabelParser: ParserFunction = (numberOfVotes: number) => `${numberOfVotes < 0 ? 0 : numberOfVotes} found this helpful`;
